const l = {
  SelfInitiatedFlow: "selfInitiatedFlow",
  SelfInitiatedFlowV2: "selfInitiatedFlowV2",
  ShareBarFlow: "shareBarFlow",
  CoApplicantFlow: "coApplicantFlow",
  ManualRenewalFlow: "manualRenewalFlow",
  UpgradeFlow: "upgradeFlow",
  DowngradeFlow: "downgradeFlow",
  AutoRenewSignUpFlow: "autoRenewSignUpFlow",
  ProductUserFlow: "productUserFlow",
  AboLedFlow: "aboLedFlow",
  SelfInitiatedFlowMultiStep: "selfInitiatedFlowMultiStep",
  GuestCheckoutFlow: "guestCheckoutFlow",
  OpsLedFlow: "opsLedFlow",
  SelfInitiatedMobileFlow: "selfInitiatedMobileFlow"
};
export {
  l as t
};
//# sourceMappingURL=RegFlowConfig-85e3badd.mjs.map
